import { z } from 'zod';
import { PinComponentSchema } from '../pin-component';
import { LayoutPartSchema } from '../pin-component/layout-part';
import { AnswerCardPinThemeSettingsSchema } from '../setting';
import { BaseInteractiveQuestionPinSettingsSchema, BasePinSchema, BaseTemplateLayoutSchema } from './base-pin';

export const WordCloudPinLayoutKeySettingsSchema = z.enum(['TITLE_ONLY']);
export type WordCloudPinLayoutKey = z.infer<typeof WordCloudPinLayoutKeySettingsSchema>;

export const WordCloudPinLayoutPartKeySchema = LayoutPartSchema.extract(['TITLE', 'IMAGE1']);

export const WordCloudPinLayoutTemplateSchema = BaseTemplateLayoutSchema.extend(
  z.object({
    key: WordCloudPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(WordCloudPinLayoutPartKeySchema, PinComponentSchema.optional()),
  }).shape
);
export type WordCloudPinLayoutTemplate = z.infer<typeof WordCloudPinLayoutTemplateSchema>;

export const WordCloudPinSettingsSchema = BaseInteractiveQuestionPinSettingsSchema.extend(
  z.object({
    word: z.string().nullish(), // in the 1.0 this was item.custom.word // TODO: Remove, use questionId instead
    layout: WordCloudPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(WordCloudPinLayoutPartKeySchema, z.string().optional()),
    answerCard: AnswerCardPinThemeSettingsSchema.optional(),
  }).shape
);

export type WordCloudPinSettings = z.infer<typeof WordCloudPinSettingsSchema>;

export const WordCloudPinTypeSchema = z.literal('WORD_CLOUD');

export const WordCloudPinSchema = BasePinSchema.extend(
  z.object({
    type: WordCloudPinTypeSchema,
    settings: WordCloudPinSettingsSchema,
  }).shape
);

export type WordCloudPin = z.infer<typeof WordCloudPinSchema>;
